import React from 'react'
import CngSection from 'src/components/cngcomponents/CngSection'
import CngField from 'src/components/cngcomponents/CngField'
import {Box, Card, Grid, Typography, useTheme } from '@material-ui/core'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import AceOcnPermitToTransferKeys from 'src/constants/locale/key/AceOcnPermitToTransfer'
import Namespace from 'src/constants/locale/Namespace'
import { useTranslation } from 'cng-web-lib'

function PermitToTransferViewContent(props) {
    const { id, data, getLookupValue } = props
    const { translate } = useTranslation(Namespace.ACE_OCN_PERMIT_TO_TRANSFER)
    const theme = useTheme()

    const translatedTextsObject = {
        aceOcnPTTManifestHeaderDTO: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.TITLE),
        scac: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.SCAC),
        vesselName: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.VESSEL_NAME),
        voyageNumber: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.VOYAGE_NUMBER),
        country: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.COUNTRY),
        portOfDischarge: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.PORT_OF_DISCHARGE),
        eta: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.ETA),
        modeOfTransport: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.MODE_OF_TRANSPORT),
        paperlessInBondParticipant: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.PAPERLESS_IN_BOND_PARTICIPANT),
        issuerScac: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.ISSUER_SCAC),
        billOfLading: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.TITLE),
        billNumber: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.BILL_OF_LADING_NUMBER),
        firmsCode: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.FIRMS_CODE),
        bondedCarrierType: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER_TYPE),
        bondedCarrier: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.BONDED_CARRIER),
        containerNumber: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.CONTAINER_NUMBER),
        quantity: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.QUANTITY),
        remarks: translate(Namespace.ACE_OCN_PERMIT_TO_TRANSFER, AceOcnPermitToTransferKeys.BillOfLading.REMARKS),
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <CngSection title={translatedTextsObject.aceOcnPTTManifestHeaderDTO}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.scac}>
                                {data.scac}
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.vesselName}>
                                {data.vesselName}
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.voyageNumber}>
                                {data.voyageNumber}
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.country}>
                                <Typography component='div' variant='inherit'>
                                    {getLookupValue('country', data.country)}
                                    <TinyChip label={data.country} variant='outlined' />
                                </Typography>
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.portOfDischarge}>
                                <Typography component='div' variant='inherit'>
                                    {getLookupValue('portOfDischarge', data.portOfDischarge)}
                                    <TinyChip label={data.portOfDischarge} variant='outlined' />
                                </Typography>
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.eta}>
                                {data.eta}
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.modeOfTransport}>
                                <Typography component='div' variant='inherit'>
                                    {getLookupValue('modeOfTransport', data.modeOfTransport)}
                                    <TinyChip  label={data.modeOfTransport} variant='outlined' />
                                </Typography>
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.paperlessInBondParticipant}>
                                <Typography component='div' variant='inherit'>
                                    {getLookupValue('paperlessInBondParticipant', data.paperlessInBondParticipant)}
                                    <TinyChip  label={data.paperlessInBondParticipant} variant='outlined' />
                               </Typography>
                            </CngField>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4}>
                            <CngField label={translatedTextsObject.issuerScac}>
                                {data.issuerScac}
                            </CngField>
                        </Grid>
                    </Grid>
                </CngSection>
            </Grid>

            <Grid item xs={12}>
                <CngSection title={"Bill of Lading"}>
                    {data.billOfLading.length > 0 ? (
                        <Grid container spacing={1}>
                            {data.billOfLading.map(bill => (
                                <Grid key={bill.id || bill._id} item xs={12}>
                                    <Card variant='outlined' style={{ backgroundColor: theme.palette.grey[50] }}>
                                        <Box padding={2}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.billNumber}>
                                                       {bill.billNumber} 
                                                    </CngField>
                                                </Grid>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.firmsCode}>
                                                        <Typography component='div' variant='inherit'>
                                                            {getLookupValue('firmsCode', bill.firmsCode)}
                                                        <TinyChip  label={bill.firmsCode} variant='outlined' />
                                                    </Typography>
                                                    </CngField>
                                                </Grid>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.bondedCarrierType}>
                                                        <Typography component='div' variant='inherit'>
                                                            {getLookupValue('bondedCarrierType', bill.bondedCarrierType)}
                                                        <TinyChip  label={bill.bondedCarrierType} variant='outlined' />
                                                    </Typography>
                                                    </CngField>
                                                </Grid>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.bondedCarrier}>
                                                        {bill.bondedCarrier}
                                                    </CngField>
                                                </Grid>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.containerNumber}>
                                                        {bill.containerNumber}
                                                </CngField>
                                                </Grid>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.quantity}>
                                                        {bill.quantity}
                                                </CngField>
                                                <Grid item xs={12} sm={4} >
                                                    <CngField label={translatedTextsObject.remarks}>
                                                        {bill.remarks}
                                                </CngField>
                                                </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Typography variant='body2' color='textSecondary'>
                            No records to display
                        </Typography>
                    )}
                </CngSection>
            </Grid>

        </Grid>
    )
}

export default PermitToTransferViewContent